import React from 'react';
import MicroLabel from '../components/MicroLabel';
import { pct, twoDigit } from '../format';

// The design spells the count out ("BEST FIVE — ALL TIME"). The lists shrink for
// small portfolios, so the word follows the count rather than being hard-coded.
const COUNT_WORDS = ['none', 'one', 'two', 'three', 'four', 'five'];

/**
 * One ranked column of holdings — best on the left in accent, worst on the right
 * in neutral.
 */
function PerformerColumn({ label, tone, holdings, best }) {
  return (
    <div className="story-performers-col">
      <MicroLabel tone={tone}>{label}</MicroLabel>

      <div className="story-performers-list">
        {holdings.map((holding, i) => (
          <div className="story-performer" key={`${holding.ticker || holding.name}-${i}`}>
            <span
              className={`story-performer-rank ${best ? 'story-performer-rank-best' : ''}`.trim()}
            >
              {twoDigit(i + 1)}
            </span>
            <span className="story-performer-name" title={holding.name}>
              {holding.name}
              {holding.ticker ? ` · ${holding.ticker}` : ''}
            </span>
            <span className="story-performer-return">{pct(holding.gainPct)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

/**
 * Chapter 05 — The heroes. And the lessons.
 *
 * Two ranked columns. The backend guarantees they are disjoint, so a user with
 * six holdings sees three a side rather than the same names celebrated and
 * mourned at once.
 */
function Performers({ story }) {
  const best = story?.topPerformers || [];
  const worst = story?.worstPerformers || [];

  return (
    <>
      <h2 className="story-h2">The heroes. And the lessons.</h2>

      {best.length === 0 ? (
        <div className="story-empty">
          <p className="story-empty-text">
            Not enough holdings to pick favourites yet.
          </p>
        </div>
      ) : (
        <div className="story-performers">
          <PerformerColumn
            label={`Best ${COUNT_WORDS[best.length] || best.length} — all time`}
            tone="accent"
            holdings={best}
            best
          />
          <PerformerColumn
            label={`Worst ${COUNT_WORDS[worst.length] || worst.length} — all time`}
            tone="muted"
            holdings={worst}
          />
        </div>
      )}
    </>
  );
}

export default Performers;
